import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import { Box, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import DownloadingIcon from "@mui/icons-material/Downloading";
import ReactPlayer from "react-player";
import { useState } from "react";

export default function VideoPreviewBox({
  open,
  onClose,
  video,
  downloadVideo,
}) {
  const fullScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const handleClose = () => {
    onClose();
  };
  const [url, setUrl] = useState(video.dropbox_link ? video.dropbox_link?.replace("www.dropbox.com", "dl.dropboxusercontent.com") : process.env.NODE_ENV === 'production' ? video?.file?.replace("http://", "https://") : video.file);

  return (
    <Dialog
      maxWidth="xl"
      fullWidth
      fullScreen={fullScreen}
      aria-labelledby="draggable-dialog-title"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        id="draggable-dialog-title"
      >
        {video.title}
        <Tooltip title="Download video">
          <IconButton
            aria-label="Download video"
            sx={{ width: 44, height: 44 }}
            onClick={() => {
              downloadVideo(video.file);
            }}
          >
            <DownloadingIcon fontSize="large" color="primary" />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <DialogContent >
        <Box height={{ xs: 220, sm: 320, md: 480 }} borderRadius={1.25} overflow={"hidden"}>
          <ReactPlayer
            component={ReactPlayer}
            url={url}
            controls
            height={"100%"}
            width={"100%"}
            light={!video.thumbnail_url ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMmyTPv4M5fFPvYLrMzMQcPD_VO34ByNjouQ&s" : video.thumbnail_url?.replace("www.dropbox.com", "dl.dropboxusercontent.com")}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose} sx={{ minHeight: 44 }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
